module.exports = __webpack_public_path__ + "static/media/dataDownloadGY.137c6433.md";